import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Image from "../../components/Image";
import { YEAR_CONFIG } from "../../utils/constants";

import "./home.scss";

export default () => (
  <div className="app">
    <Header curPage="home" subPage="home" />
    <div className="app-body">
      <div className="intro-banner">
        <p className="intro-title">
          以科技为引擎
          <br />
          共筑绿水青山
        </p>
        <span className="intro-desc">
          美团青山科技基金是美团发起设立的公益性基金，旨在鼓励更多科研力量投身环保研究，
          助力绿色低碳基础科研及技术成果转化，推动行业绿色发展，实现美丽中国愿景蓝图。
        </span>
      </div>
      <div className="award-intro-container">
        <div className="award-title-content award">
          <p>青山科技奖</p>
          <span>
            {YEAR_CONFIG.description}
          </span>
        </div>
        <div className="award-intro-content">
          <p>{YEAR_CONFIG.year}重点关注议题</p>
          <div className="icon-list">
            <div className="icon">
              <Image name="青山移动端/绿色低碳包装" />
              <span>绿色低碳材料</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/碳捕集和利用" />
              <span>碳捕集及资源化利用</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/低碳运输及储能" />
              <span>新能源及储能</span>
            </div>
          </div>
          <div className="icon-list">
            <div className="icon">
              <Image name="青山移动端_减污降碳协同控制" />
              <span>降碳减污协同控制</span>
            </div>
          </div>
          <p>{YEAR_CONFIG.year}资助学科领域</p>
          <div className="icon-list">
            <div className="icon">
              <Image name="青山移动端/材料科学" />
              <span>材料科学</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/化学" />
              <span>化学</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/化工工程" />
              <span>化学工程</span>
            </div>
          </div>
          <div className="icon-list">
            <div className="icon">
              <Image name="青山移动端/环境科学" />
              <span>环境科学技术</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/能源科学" />
              <span>能源科学技术</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/前沿交叉" />
              <span>前沿交叉</span>
            </div>
          </div>
          <p>{YEAR_CONFIG.year}青山科技奖奖项说明</p>
          <div className="award-info-content">
            <div>
              <p>奖励名额</p>
              <strong>10</strong>
              <span>
                中国内地及港澳地区工作的
                <br />
                45周岁及以下青年科研工作者
              </span>
            </div>
            <div>
              <p>奖金</p>
              <strong>1,000,000</strong>
              <span>人民币/人</span>
            </div>
          </div>
        </div>
      </div>
      <div className="award-intro-container">
        <div className="award-intro-content award-schedule-content">
          <div className="award-title">第{YEAR_CONFIG.period}届青山科技奖评奖日程</div>
          {YEAR_CONFIG.scheduleItems.map((item) => (
            <div key={item.serial} className="award-schedule-item">
              <span className="serial">{item.serial}</span>
              <span className="schedule">{item.schedule}</span>
              <span className="date">{item.date}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="award-intro-container">
        <div className="award-title-content environment">
          <p>“科创中国”美团青山环保科技创新示范项目</p>
          <span>
            聚焦绿色创新包装、绿色回收再生、绿色供应链体系三大领域。通过公开征集具有创新性、环保性、示范性的先进技术和项目，促进一批环保创新科技成果应用落地，形成可复制的示范案例，推进外卖行业绿色低碳循环发展。
          </span>
        </div>
        <div className="award-intro-content">
          <div className="icon-list">
            <div className="icon">
              <Image name="青山移动端/创新性" />
              <span>创新性</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/环保性" />
              <span>环保性</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/示范性" />
              <span>示范性</span>
            </div>
          </div>
          <p>申报领域</p>
          <div className="icon-list">
            <div className="icon">
              <Image name="青山移动端/绿色创新包装应用" />
              <span>绿色创新包装</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/绿色回收技术应用" />
              <span>绿色回收再生</span>
            </div>
            <div className="icon">
              <Image name="青山移动端/绿色供应链数字化" />
              <span>绿色供应链体系</span>
            </div>
          </div>
          <p>项目说明</p>
          <div className="award-info-content">
            <div>
              <p>资助数量</p>
              <strong>≤10</strong>
              <span>
                面向中国境内依法注册的
                <br />
                法人主体
              </span>
            </div>
            <div>
              <p>资助金额</p>
              <strong>≤3,000,000</strong>
              <span>人民币/项目</span>
              {/* <span>单个入选项目将获得最高300万人民币资金支持</span> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);
